import { render, staticRenderFns } from "./StudioSearchBar.vue?vue&type=template&id=44363244"
import script from "./StudioSearchBar.vue?vue&type=script&lang=js"
export * from "./StudioSearchBar.vue?vue&type=script&lang=js"
import style0 from "./StudioSearchBar.vue?vue&type=style&index=0&id=44363244&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports